import { QuickApiServiceBase, QuickConsoleLogger } from 'hooks/services';
import { appApiProvider } from './axiosApiProvider';
import { IFormApplicationDTO } from 'shared/interfaces/formApplication';
import { otpService } from './otp.servic';

class ApplicationsService extends QuickApiServiceBase {
    constructor() {
        super(new QuickConsoleLogger('ApplicationsService'), appApiProvider, 'applications', 'Applications');
    }

    /** External users only: get application by id using OTP session token (attached automatically by interceptor). */
    public async getById(id: string): Promise<IFormApplicationDTO> {
        try {
            return await this.getOrThrow({ url: `/get-by-id/${id}` });
        } catch (error: any) {
            if (error.response?.status === 401 || error.response?.status === 403) {
                otpService.clearSessionToken(id);
            }
            throw error;
        }
    }

    public async update(application: IFormApplicationDTO): Promise<IFormApplicationDTO> {
        const id = application._id;
        return this.putOrThrow(application, { url: `/update/${id}` });
    }
}

export const applicationsService = new ApplicationsService();
